import PageFooter from './page-footer'

export default PageFooter



// WEBPACK FOOTER //
// ./src/views/my-components/page-footer/index.js